import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { TodoItem } from "@/types/todo";

interface TodoCardProps {
  todo: TodoItem;
}

const TodoCard = ({ todo }: TodoCardProps) => {
  const getComplexityColor = (complexity: string) => {
    switch (complexity) {
      case "Low":
        return "bg-green-500";
      case "Medium":
        return "bg-yellow-500";
      case "High":
        return "bg-red-500";
      default:
        return "bg-gray-500";
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Not Started":
        return "bg-gray-500";
      case "In Progress":
        return "bg-blue-500";
      case "Completed":
        return "bg-green-500";
      default:
        return "bg-gray-500";
    }
  };

  return (
    <div className="p-4 rounded-lg bg-white/5 hover:bg-white/10 transition-colors">
      <div className="flex justify-between items-start mb-2">
        <h3 className="font-medium">{todo.title}</h3>
        <div className="flex gap-2">
          <Badge
            variant="secondary"
            className={getComplexityColor(todo.complexity)}
          >
            {todo.complexity}
          </Badge>
          <Badge
            variant="secondary"
            className={getStatusColor(todo.status)}
          >
            {todo.status}
          </Badge>
        </div>
      </div>
      <p className="text-sm text-muted-foreground mb-3">
        {todo.description}
      </p>
      <Progress value={todo.progress} className="h-1.5" />
    </div>
  );
};

export default TodoCard;